import { FormEvent, useState } from "react";
import { login } from "../lib/api";

export function Login({ onLogin }: { onLogin: () => void }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  async function submit(event: FormEvent) {
    event.preventDefault();
    setError("");
    try {
      await login(email, password);
      onLogin();
    } catch {
      setError("The email or password was not accepted.");
    }
  }

  return (
    <main className="login-screen">
      <form className="login-card" onSubmit={submit}>
        <div className="brand-mark">BL</div>
        <h1>Builtlocally Command Center</h1>
        <p>Private CRM access for clients, referral partners, community nodes, reports, and owner operations.</p>
        <label>
          <span>Email</span>
          <input type="email" value={email} onChange={(event) => setEmail(event.target.value)} autoComplete="email" autoFocus />
        </label>
        <label>
          <span>Password</span>
          <input type="password" value={password} onChange={(event) => setPassword(event.target.value)} autoComplete="current-password" />
        </label>
        {error ? <small className="form-error">{error}</small> : null}
        <button type="submit">Sign in</button>
      </form>
    </main>
  );
}
